import {observable, computed} from 'mobx';

class UserGroup {
  id = null;

  @computed get key() {
    return this.id;
  }

  @computed get title() {
    return this.name;
  }

  @observable name;

  @observable description;

  @observable createdBy;

  @observable createdTime;

  @observable createdByOperatingUser;

  constructor(store, id) {
    this.store = store;
    this.id = id;
  }

  updateFromJson(json) {
    this.name = json.name;
    this.description = json.description;
    this.createdBy = json.createdBy;
    this.createdTime = json.createdTime;
    this.createdByOperatingUser = json.createdByOperatingUser;
  }
}

export default UserGroup;
